import { Link } from 'react-router-dom';
import { articles } from '@/mocks/mahjong';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function ArticlesPage() {
  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: '麻将攻略 - 在线麻将牌',
          description: '从入门到精通的麻将攻略大全，包含国标麻将、广东麻将、四川麻将等多种玩法的技巧和策略指南。',
          url: 'https://tileblast.github.io/articles',
          isPartOf: {
            '@type': 'WebSite',
            name: '在线麻将牌',
          },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://tileblast.github.io' },
            { '@type': 'ListItem', position: 2, name: '麻将攻略' },
          ],
        }}
      />

      <div className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '麻将攻略' },
            ]}
          />
        </div>

        {/* Hero */}
        <section className="relative w-full h-[250px] md:h-[350px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Collection%20of%20mahjong%20strategy%20books%20and%20tiles%20on%20a%20dark%20green%20felt%20table%2C%20warm%20reading%20lamp%20lighting%2C%20intellectual%20atmosphere%2C%20scholarly%20vibe%2C%20professional%20photography%2C%20rich%20textures&width=1920&height=700&seq=articles-hero&orientation=landscape"
            alt="麻将攻略 - 在线麻将牌"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-white mb-3">
              麻将攻略大全
            </h1>
            <p className="text-white/80 max-w-xl text-sm md:text-base">
              从入门到精通的麻将攻略，全方位提升你的麻将水平
            </p>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {articles.map((article) => (
                <article key={article.slug}>
                  <Link
                    to={`/article/${article.slug}`}
                    className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer h-full"
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        title={article.title}
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-2 mb-3">
                        <span className="bg-secondary-100 text-secondary-700 text-xs px-2.5 py-0.5 rounded-full whitespace-nowrap">
                          {article.categoryName}
                        </span>
                        <span className="text-xs text-foreground-500 whitespace-nowrap">
                          {article.date}
                        </span>
                      </div>
                      <h2 className="font-heading font-semibold text-foreground-900 mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between text-xs text-foreground-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {article.readTime}
                        </span>
                        <span className="flex items-center gap-1 text-primary-600 group-hover:translate-x-1 transition-transform">
                          阅读全文
                          <i className="ri-arrow-right-line"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}